module.exports = __webpack_public_path__ + "static/media/dlbLogo.6922ee51.png";